import { Link } from 'react-router-dom';
import type { Drama } from '@/types/drama';

interface LatestUpdatesProps {
  items: Drama[];
}

export default function LatestUpdates({ items }: LatestUpdatesProps) {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950">最新更新</h2>
          <p className="mt-2 text-sm text-foreground-500">按更新时间排序，第一时间追上最新剧集</p>
        </div>
        <Link to="/category" className="text-sm text-primary-700 hover:text-primary-600 font-medium inline-flex items-center gap-1 whitespace-nowrap">
          浏览全部剧集
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
        {items.map((drama, index) => (
          <Link
            key={drama.id}
            to={`/detail/${drama.id}`}
            className="group flex items-center gap-4 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 animate-fade-up cursor-pointer"
            style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
          >
            <div className="relative w-16 h-24 md:w-20 md:h-28 shrink-0 rounded-md overflow-hidden bg-background-200">
              <img
                src={drama.cover}
                alt={`${drama.title}海报`}
                title={`${drama.title} 最新更新 - 香草视频`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
                {drama.title}
              </h3>
              <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
                {drama.types.slice(0, 2).map((type) => (
                  <span key={type} className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-900">
                    {type}
                  </span>
                ))}
              </div>
              <p className="mt-2 text-xs text-foreground-500 truncate">
                更新至 {drama.currentEpisodes} 集 / 共 {drama.totalEpisodes} 集
              </p>
              <p className="mt-1 text-xs text-foreground-400 flex items-center gap-1">
                <i className="ri-time-line" />
                {drama.updatedAt} 更新
              </p>
            </div>
            <span className="hidden sm:flex w-9 h-9 items-center justify-center rounded-full bg-primary-50 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
              <i className="ri-arrow-right-s-line text-xl" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}